import { render, staticRenderFns } from "./EquipTypeNewBtn.vue?vue&type=template&id=68501844"
import script from "./EquipTypeNewBtn.vue?vue&type=script&lang=js"
export * from "./EquipTypeNewBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports